import { rootProtectedPath, services } from "data/authData";
import MoveToInboxRounded from "@mui/icons-material/MoveToInboxRounded";
import NotesIcon from "@mui/icons-material/Notes";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import InventoryIcon from "@mui/icons-material/Inventory";
import GroupsIcon from "@mui/icons-material/Groups";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import DepartureBoardIcon from "@mui/icons-material/DepartureBoard";
import Groups2Icon from "@mui/icons-material/Groups2";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import LocalMallIcon from "@mui/icons-material/LocalMall";
import StoreIcon from "@mui/icons-material/Store";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import DatasetIcon from "@mui/icons-material/Dataset";
import BookIcon from "@mui/icons-material/Book";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import CallMadeIcon from "@mui/icons-material/CallMade";

export const customQuereiesDrawerElements = {
	planning_sale_query: {
		name: "Planning Sale Query",
		key: "planning_sale_query",
		display: true,
		icon: <NotesIcon />,
	},
	all_channel_dispatch: {
		name: "All Channel Dispatch",
		key: "all_channel_dispatch",
		display: true,
		icon: <LocalShippingIcon />,
	},

	inventory_snapshot: {
		name: "Inventory Snapshot",
		key: "inventory_snapshot",
		display: true,
		icon: <InventoryIcon />,
	},
	git: {
		name: "GIT",
		key: "git",
		display: true,
		icon: <DepartureBoardIcon />,
	},
	tir: {
		name: "Inward Register",
		key: "tir",
		display: true,
		icon: <ArrowCircleRightIcon />,
	},
	ecom_sales: {
		name: "ECOM SALES",
		key: "ecom_sales",
		display: true,
		icon: <LocalMallIcon />,
	},
	ebo_sales: {
		name: "EBO SALES",
		key: "ebo_sales",
		display: true,
		icon: <StoreIcon />,
	},

	soh: {
		name: "SOH",
		key: "soh",
		display: true,
		icon: <Inventory2Icon />,
		types: {
			shopify_soh: {
				name: "Shopify SOH",
				key: "shopify_soh",
				display: true,
				icon: <Inventory2Icon />,
			},
			historical_soh: {
				name: "Historical SOH",
				key: "historical_soh",
				display: true,
				icon: <Inventory2Icon />,
			},
			ebo_soh_daily: {
				name: "EBO SOH Daily",
				key: "ebo_soh_daily",
				display: true,
				icon: <MoveToInboxRounded />,
			},
		},
	},
	store_register: {
		name: "Store Register",
		key: "store_register",
		display: true,
		icon: <BookIcon />,
		types: {
			goods_receive_register: {
				name: "Goods Receive Register",
				key: "goods_receive_register",
				display: true,
				icon: <CallReceivedIcon />,
			},
			goods_return_register: {
				name: "Goods Return Register",
				key: "goods_return_register",
				display: true,
				icon: <CallMadeIcon />,
			},
		},
	},
	customer_cohort: {
		name: "Customer Cohort",
		key: "customer_cohort",
		display: true,
		icon: <ManageAccountsIcon />,
		types: {
			customer_count: {
				name: "Customer Count",
				key: "customer_count",
				display: true,
				icon: <GroupsIcon />,
			},
			count_of_bill: {
				name: "Count of Bill",
				key: "count_of_bill",
				display: true,
				icon: <ReceiptLongIcon />,
			},
			realised_value: {
				name: "Realised Value",
				key: "realised_value",
				display: true,
				icon: <CurrencyRupeeIcon />,
			},
		},
	},
	item_master: {
		name: "Item Master",
		key: "item_master",
		display: true,
		icon: <DatasetIcon />,
	},
};

export const selectOptKeyName = "select_options";
export const replenishmentParamName = "tab";

export const allOption = "ALL";

export const planningSaleQueryPath = `/${rootProtectedPath}/${services.custom_queries.path}/${customQuereiesDrawerElements.planning_sale_query.key}`;
